import {
    getCznIndicatorsByIndicatorId,
    getRegionIndicatorsByPeriod,
} from "@/modules/api.indicators";
import {filterMonitorRegions, isMonitorRegion} from "@/modules/ActivityMonitorRatingRegions";

let departmentsByRegion;

export function setDepartmentsByRegion(val) {
    departmentsByRegion = JSON.parse(JSON.stringify(val));
}

export const DOMAIN_INDICATORS_RATING = 'activity_monitor_indicators_rating';

function parseValuesToFloat(values) {
    return values.map(item => ({
        ...item,
        value: item.value == null || item.value === '' ? null : parseFloat(item.value),
    }));
}

function normalizeRating(rating) {
    return rating
        .map(e => [e[0], e[1] == null ? 0 : e[1] * 100])
        .sort((a, b) => a[1] <= b[1] ? 1 : -1);
}

export async function getActivityMonitorRating(ratingIndicatorId, level, period, regionAndDepartmentInfo) {
    if (level === 'region') {
        const values = parseValuesToFloat(
            (await getCznIndicatorsByIndicatorId(DOMAIN_INDICATORS_RATING, 0, ratingIndicatorId)).payload
        );

        const regions = filterMonitorRegions(departmentsByRegion || []);
        return normalizeRating(regions.map(region => {
            const value = values.find(v =>
                v.regionCode === region.code &&
                v.period === period.code &&
                (v.cznId == null || v.cznId === 0)
            )?.value;
            return [region.name, value];
        }));
    }

    const region = departmentsByRegion?.find(e => e.code === regionAndDepartmentInfo?.region?.code);
    if (!region || !isMonitorRegion(region.code)) return [];

    const values = parseValuesToFloat(
        (await getRegionIndicatorsByPeriod(DOMAIN_INDICATORS_RATING, region.code, period.code, 'FILLED')).payload
    );

    const departments = (region.departments || []).filter(d => d.type === 'territorial_czn');
    return normalizeRating(departments.map(department => {
        const value = values.find(v =>
            v.indicatorId === ratingIndicatorId &&
            v.cznId === department.id &&
            v.period === period.code
        )?.value;
        return [department.name, value];
    }));
}

export function createRatingDataFunction(ratingIndicatorId) {
    return (level, period, regionAndDepartmentInfo) =>
        getActivityMonitorRating(ratingIndicatorId, level, period, regionAndDepartmentInfo);
}
